import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { WorkingCenterCounterModelType } from '@teinor/erp/types/company/workingCenter/workingCenterCounter'
import { arrayFromArrayDictionaryAttribute } from '../../globals/array'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../globals/dictionary'
import { WorkingCenterPaymentMethodModelType } from '@teinor/erp/types/company/workingCenter/workingCenterPaymentMethod'
import { WorkingCenterChargingMethodModelType } from '@teinor/erp/types/company/workingCenter/workingCenterChargingMethod'
import { WarehouseModelType } from '@teinor/erp/types/company/warehouse'
import { WorkingCenterBankModelType } from '@teinor/erp/types/company/workingCenter/workingCenterBank'


type WorkingCenterModelTypeDictFulls = WorkingCenterModelType & {
    dictCounters: {[id: number]: WorkingCenterCounterModelType}
    dictBanks: {[id: number]: WorkingCenterBankModelType}
    dictPaymentMethods: {[id: number]: WorkingCenterPaymentMethodModelType}
    dictChargingMethods: {[id: number]: WorkingCenterChargingMethodModelType}
    dictWarehouses: {[id: number]: WarehouseModelType}
    idWarehouses: number[]
    warehouseMain: number | null
    bankDefault: number | null
} 
export interface WorkingCentersAction {
    type: 'CHANGE_WORKINGCENTER'
    payload: WorkingCenterModelType[] 
}
export type DictionaryWorkingCenter = { [id: number]: WorkingCenterModelTypeDictFulls }
export type WorkingCenterPayload = null | DictionaryWorkingCenter

export default function workingCenter(state: WorkingCenterPayload = null, action: WorkingCentersAction): DictionaryWorkingCenter | null {
    switch (action.type) {
        case 'CHANGE_WORKINGCENTER':
            const dictionaryWorkingCenter: DictionaryWorkingCenter = dictionaryComplexFromJsonArr(action.payload || [])
            for (const key in dictionaryWorkingCenter) {
                const workingCenter = dictionaryWorkingCenter[key]
                let myWorkingCenterCounters = workingCenter?.WorkingCenterCounters
                if (workingCenter?.CounterWorkingCenterId) {
                    myWorkingCenterCounters = dictionaryWorkingCenter?.[workingCenter?.CounterWorkingCenterId]?.WorkingCenterCounters || workingCenter?.CounterWorkingCenter?.WorkingCenterCounters || []
                }
                if (myWorkingCenterCounters && myWorkingCenterCounters?.length){
                    workingCenter['dictCounters'] = dictionaryComplexFromJsonArr(myWorkingCenterCounters)
                }
                if(workingCenter.WorkingCenterBanks && workingCenter.WorkingCenterBanks.length){
                    const dictBanks: TwinDictionary = {}
                    for (const bank of workingCenter.WorkingCenterBanks) {
                        dictBanks[bank.id] = { ...bank, fullname: bank.name + '-' + bank.iban }
                        if(bank.defaultBank){
                            workingCenter.bankDefault = bank.id
                        }
                    }
                    workingCenter['dictBanks'] = dictBanks
                }
                if(workingCenter.WorkingCenterPaymentMethods && workingCenter.WorkingCenterPaymentMethods.length){
                    workingCenter['dictPaymentMethods'] = dictionaryComplexFromJsonArr(workingCenter.WorkingCenterPaymentMethods)
                }
                if(workingCenter.WorkingCenterChargingMethods && workingCenter.WorkingCenterChargingMethods.length){
                    workingCenter['dictChargingMethods'] = dictionaryComplexFromJsonArr(workingCenter.WorkingCenterChargingMethods)
                }
                if (workingCenter.Warehouses && workingCenter.Warehouses.length) {
                    workingCenter['idWarehouses'] = arrayFromArrayDictionaryAttribute(workingCenter.Warehouses, 'id')
                    workingCenter['dictWarehouses'] = dictionaryComplexFromJsonArr(workingCenter.Warehouses)
                    let myWarehouseMain = null
                    for (const element of workingCenter.Warehouses) {
                        //@ts-ignore
                        if (element.WarehouseWorkingCenter.is_main) {
                            myWarehouseMain = element.id
                            break
                        }
                    }
                    workingCenter['warehouseMain'] = myWarehouseMain
                }
            }
            return state = {...dictionaryWorkingCenter}
        default:
            return state
    }
}